import { useCallback, useRef } from 'react';
import {
  InstitutionProps,
  useLazyGetAllInstitutionsQuery,
} from '../../redux/features/institucioni/institucioni-api';
import { usePaginatedData } from '../../hooks/usePaginatedData';

export const useInstitution = (emri = '') => {
  const [getAllInstitutions] = useLazyGetAllInstitutionsQuery();

  const getAllInstitutionsRef = useRef(getAllInstitutions);
  getAllInstitutionsRef.current = getAllInstitutions;

  const request = useCallback(
    (params: { emri?: string; page: number; size: number }) =>
      getAllInstitutionsRef.current(params),
    [],
  );

  const { data: institutionOptions, popupScroll } = usePaginatedData<
    InstitutionProps,
    { emri?: string }
  >({
    request,
    query: { emri },
    fetch: true,
    resetOn: [emri],
  });

  return { institutionOptions, popupScroll };
};
